import React from "react";
import LgvDateField from "../../../components/LgvDateField";
import { QuestionItem } from "../../../types/form";
import { getDateBoundsForInput } from "../../../utils/validationRules";

interface DateFieldRendererProps {
  question: QuestionItem;
  inputName: string;
  currentValue: unknown;
  formData?: Record<string, any>;
  setFormData: React.Dispatch<React.SetStateAction<Record<string, any>>>;
  handleMultipleEntryChange: (
    inputName: string,
    idx: number,
    value: unknown,
  ) => void;
  handleAddEntry: (inputName: string) => void;
  handleRemoveEntry: (inputName: string, entryIdx: number) => void;
  readOnly?: boolean;
}

const DateFieldRenderer: React.FC<DateFieldRendererProps> = ({
  question,
  inputName,
  currentValue,
  formData,
  setFormData,
  handleMultipleEntryChange,
  handleAddEntry,
  handleRemoveEntry,
  readOnly = false,
}) => {
  const dateBounds = getDateBoundsForInput(question, formData);

  if (question.allowMultipleAnswers) {
    const entriesArray = Array.isArray(currentValue)
      ? currentValue
      : [currentValue ?? ""];

    return (
      <div className="space-y-3">
        {entriesArray.map((entryValue, idx) => (
          <div key={idx} className="flex items-center gap-2">
            <LgvDateField
              id={idx === 0 ? inputName : `${inputName}-${idx}`}
              name={idx === 0 ? inputName : undefined}
              value={String(entryValue ?? "")}
              min={dateBounds.min}
              max={dateBounds.max}
              disabled={readOnly}
              placeholder={question.placeholder}
              onChange={(value) => handleMultipleEntryChange(inputName, idx, value)}
            />
            {idx > 0 && (
              <button
                type="button"
                onClick={() => handleRemoveEntry(inputName, idx)}
                disabled={readOnly}
                className="px-3 py-2 text-red-600 border border-red-600 rounded-md hover:bg-red-50 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
              >
                Remove
              </button>
            )}
          </div>
        ))}
        <button
          type="button"
          onClick={() => handleAddEntry(inputName)}
          disabled={readOnly}
          className="px-4 py-2 bg-[#1B365D] text-white rounded-md hover:bg-[#152a4a] transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
        >
          + Add Another
        </button>
      </div>
    );
  }

  return (
    <LgvDateField
      id={inputName}
      name={inputName}
      value={String(currentValue ?? "")}
      min={dateBounds.min}
      max={dateBounds.max}
      disabled={readOnly}
      placeholder={question.placeholder}
      onChange={(value) =>
        setFormData((prev) => ({
          ...prev,
          [inputName]: value,
        }))
      }
    />
  );
};

export default DateFieldRenderer;
